"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3081],{

/***/ 99435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ partners_PartnersPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/components/api/index.ts + 2 modules
var api = __webpack_require__(67945);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(77997);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/components/shared/Footer.tsx + 2 modules
var Footer = __webpack_require__(13390);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/complex/CtaInput/CtaInput.mjs
var CtaInput = __webpack_require__(94801);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Card/Card.mjs
var Card = __webpack_require__(63282);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Heading/Heading.mjs
var Heading = __webpack_require__(37982);
;// CONCATENATED MODULE: ./src/components/partners/ValuePropsSection.tsx




var Item = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        width: "100%",
        $largerThanSM: {
            width: "25%",
            marginBottom: 0
        },
        style: {
            textAlign: "left"
        },
        marginBottom: "$8x",
        children: props.children
    });
};
var Title = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
        size: "UNSAFE_h4",
        as: "h4",
        fontSize: [
            "s1",
            "s2"
        ],
        fontWeight: "bolder",
        width: [
            "100%",
            "100%",
            "80%"
        ],
        lineHeight: "header",
        mb: [
            4,
            null,
            null,
            6
        ],
        color: "neutrals0",
        height: [
            null,
            null,
            "60px"
        ],
        children: props.children
    });
};
var Description = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
        tag: "p",
        ml: 0,
        color: "$contentInversePrimary",
        typography: "$bodySmall",
        width: "80%",
        $largerThanMD: {
            width: "85%"
        },
        children: props.children
    });
};
var ValuePropsSection = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
        mt: [
            11,
            null,
            12
        ],
        flexDirection: "column",
        width: "100%",
        textAlign: "center",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
            alignItems: "flex-start",
            justifyContent: "evenly-spaced",
            flexDirection: [
                "column",
                "column",
                "row",
                "row"
            ],
            margin: "auto",
            children: props.valueProps.map(function(valueProp, i) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Item, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                            children: valueProp.header
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                            children: valueProp.description
                        })
                    ]
                }, i);
            })
        })
    });
};
/* harmony default export */ var partners_ValuePropsSection = (ValuePropsSection);

;// CONCATENATED MODULE: ./src/components/partners/Hero.tsx





var Hero = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.C, {
        className: "hero-container",
        mt: 11,
        mx: 4,
        pt: 11,
        backgroundColor: "brand50",
        backgroundSize: "cover",
        borderRadius: [
            "none",
            null,
            "semiRounded"
        ],
        height: [
            null,
            null,
            null,
            "600px"
        ],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex/* default */.Z, {
            flexDirection: "column",
            alignItems: "start",
            width: "100%",
            padding: [
                "0% 5% 0%",
                null,
                null,
                "0"
            ],
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "start",
                margin: [
                    "0 auto 45%",
                    "0 auto 25%",
                    "0 auto 25%",
                    "0 auto 25%"
                ],
                px: [
                    3,
                    0
                ],
                maxWidth: "929px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        //Mark Title as h1 for SEO
                        tag: "h1",
                        typography: "$headerSmall",
                        mb: "$7x",
                        color: "$contentInversePrimary",
                        textAlign: "left",
                        $largerThanSM: {
                            maxWidth: "50%"
                        },
                        ml: 0,
                        children: props.headerText
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        width: "100%",
                        height: "$32x",
                        marginTop: "$2x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaInput/* default */.Z, {
                                designStyle: "roundedSquare",
                                placeholderText: props.placeholder,
                                inputType: props.inputType,
                                onChange: props.onEmailChange,
                                value: props.emailValue,
                                unboundedWidth: true,
                                onSubmit: props.onSubmit,
                                paddingLevel: "light",
                                ctaProps: {
                                    /** TODO @partnerships Semantic buttons without onClick methods are a11y violations. See https://opendoor.atlassian.net/wiki/spaces/SELL/pages/1943339236/Accessibility+best+practices+for+frontend+development#Adding-onClick-handlers-to-non-interactive-elements-such-as-%3Cdiv-/%3E-or-%3CBox-/%3E-not-started */ onClick: function() {},
                                    actionText: "Get started",
                                    "aria-label": "",
                                    loading: props.loading
                                }
                            }),
                            props.isEmailInvalid && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                backgroundColor: "$backgroundStateInactiveAccentError",
                                typography: "$labelSmall",
                                pl: "$4x",
                                py: "$4x",
                                color: "$contentInversePrimary",
                                textAlign: "left",
                                borderRadius: "$4x",
                                mt: 3,
                                children: "Please use an email address associated with your builder to continue."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(partners_ValuePropsSection, {
                        valueProps: [
                            {
                                header: "Streamline your process",
                                description: "Create a custom profile to track and manage every touch point of your customer’s journey."
                            },
                            {
                                header: "Help your client get started",
                                description: "Help your client get started. Use the Home Eligibility Checker to confirm your client’s home is eligible."
                            },
                            {
                                header: "Sell more homes, faster",
                                description: "Get your clients a competitive estimated offer within minutes — all with a few simple clicks."
                            },
                            {
                                header: "Access dedicated support",
                                description: "Access your own partner manager, training, insights, and more to help you sell more homes."
                            }, 
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var partners_Hero = (Hero);

;// CONCATENATED MODULE: ./src/components/partners/BuilderSalesPage.tsx









var BuilderSalesPage = function(props) {
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var ref = (0,react.useState)(), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(), ctaInputLoading = ref1[0], setCtaInputLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isEmailInvalid = ref2[0], setIsEmailInvalid = ref2[1];
    var onEmailChange = function(_event, value) {
        setEmail(value);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                event.preventDefault();
                setCtaInputLoading(true);
                if (!email) {
                    return [
                        2
                    ];
                }
                api/* validatePartnerEmailAddress */.il(email).then(function(resp) {
                    if (!resp || !resp.validateEmail.isValid) {
                        setIsEmailInvalid(true);
                        setCtaInputLoading(false);
                        // TODO: remove categoryOverride
                        // observability is initialized with 'cosmos' as the category for all events
                        trackEvent("invalid-email", undefined, {
                            email: email
                        }, {
                            categoryOverride: "partner-sign-up-flow"
                        });
                        return;
                    }
                    // TODO: remove categoryOverride
                    // observability is initialized with 'cosmos' as the category for all events
                    trackEvent("valid-email", undefined, undefined, {
                        categoryOverride: "partner-sign-up-flow"
                    });
                    setEmail(resp.validateEmail.normalizedEmail);
                    var redirectParams = new URLSearchParams();
                    redirectParams.set("email", email);
                    redirectParams.set("partnershipType", props.partnerChannel);
                    redirectParams.set("role", props.signUpRole);
                    if (props.partnerIdentifier) {
                        redirectParams.set("partnerIdentifier", props.partnerIdentifier);
                    }
                    window.location.assign("".concat(globals/* PARTNERSHIP_BFF_URL */.Ff, "/sign-up?").concat(redirectParams.toString()));
                }).catch(function() {
                    setCtaInputLoading(false);
                });
                return [
                    2
                ];
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(partners_Hero, {
                headerText: "Sign up for your customized dashboard today",
                inputType: "email",
                placeholder: "Enter your work email",
                emailValue: email,
                isEmailInvalid: isEmailInvalid,
                onEmailChange: onEmailChange,
                onSubmit: handleSubmit,
                loading: ctaInputLoading
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var partners_BuilderSalesPage = (BuilderSalesPage);

;// CONCATENATED MODULE: ./src/components/partners/PartnersPage.tsx








var PartnersPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(PartnersPage, _Component);
    var _super = (0,_create_super/* default */.Z)(PartnersPage);
    function PartnersPage() {
        (0,_class_call_check/* default */.Z)(this, PartnersPage);
        return _super.apply(this, arguments);
    }
    var _proto = PartnersPage.prototype;
    _proto.componentDidMount = function componentDidMount() {
        observability_slim/* analytics.trackEvent */.co.trackEvent("partner-sign-up-flow", "view-landing-page");
    };
    _proto.render = function render() {
        var _props = this.props, partnerChannel = _props.partnerChannel, signUpRole = _props.signUpRole;
        if (partnerChannel === "HOME_BUILDER" && signUpRole === "partner_sales_referrer") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(partners_BuilderSalesPage, (0,_object_spread/* default */.Z)({}, this.props));
        }
        return null;
    };
    return PartnersPage;
}(react.Component);
/* harmony default export */ var partners_PartnersPage = (PartnersPage);


/***/ }),

/***/ 69224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.js
var aos = __webpack_require__(2711);
// EXTERNAL MODULE: ./node_modules/@opendoor/shared-fe/build/faviconPath.js
var faviconPath = __webpack_require__(71390);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
;// CONCATENATED MODULE: ./src/components/WordpressPorts.tsx










var NextHead = (head_default());
var metaDescription = "Opendoor is the new way to sell your home. " + "Skip the hassle of listing, showings and months of stress, and " + "close on your own timeline. Get a free offer today!";
var Head = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NextHead, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: "Opendoor | Sell your home the minute you’re ready."
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: metaDescription
            }, "description"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "viewport",
                content: "width=device-width,initial-scale=1"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                httpEquiv: "Accept-CH",
                content: "DPR, Width, Viewport-Width"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "shortcut icon",
                href: (0,faviconPath/* default */.Z)({
                    railsEnv: globals/* DEPLOY_ENV */.Zp
                }),
                type: "image/png"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "apple-touch-icon",
                sizes: "144x144",
                href: "https://www.opendoor.com/apple-touch-icon-144.png"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "preload",
                crossOrigin: "anonymous",
                href: "/fonts/graphik-regular/Graphik-Regular.woff",
                as: "font"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "preload",
                crossOrigin: "anonymous",
                href: "/fonts/graphik-medium/Graphik-Medium.woff",
                as: "font"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "preload",
                crossOrigin: "anonymous",
                href: "/fonts/graphik-semibold/Graphik-Semibold.woff",
                as: "font"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "preload",
                crossOrigin: "anonymous",
                href: "/fonts/graphik-bold/Graphik-Bold.woff",
                as: "font"
            })
        ]
    });
};
var Page = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Page, _Component);
    var _super = (0,_create_super/* default */.Z)(Page);
    function Page() {
        (0,_class_call_check/* default */.Z)(this, Page);
        return _super.apply(this, arguments);
    }
    var _proto = Page.prototype;
    _proto.componentDidMount = function componentDidMount() {
        window.requestAnimationFrame(function() {
            aos.init();
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-ms-flex:1;-webkit-flex:1;flex:1;margin:0 auto;background-color:#fff;position:relative;"),
            children: this.props.children
        });
    };
    return Page;
}(react.Component);

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(54991);
// EXTERNAL MODULE: ./src/components/shared/Header.tsx
var Header = __webpack_require__(92013);
// EXTERNAL MODULE: ./src/components/shared/MenuPanel.tsx
var MenuPanel = __webpack_require__(37197);
;// CONCATENATED MODULE: ./src/components/shared/Layout.tsx








var assetPrefix = "/fonts";
var GlobalCss = "\n@font-face {\n  font-family: 'Publico, serif';\n  src: url('".concat(assetPrefix, "/PublicoHeadline-Bold-Web.eot?#iefix')\n      format('embedded-opentype'),\n    url('").concat(assetPrefix, "/PublicoHeadline-Bold-Web.woff') format('woff'),\n    url('").concat(assetPrefix, "/PublicoHeadline-Bold-Web.ttf') format('truetype'),\n    url('").concat(assetPrefix, "/PublicoHeadline-Bold-Web.svg#PublicoHeadline-Bold-Web') format('svg');\n  font-weight: 600;\n  font-style: bolder;\n}\n");
var Layout = function(props) {
    var ref = (0,react.useState)(false), isMenuOpen = ref[0], setMenuOpen = ref[1];
    var toggleMenuOpen = function() {
        return setMenuOpen(!isMenuOpen);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            Head(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                        children: "Opendoor"
                    }, "title"),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/PublicoHeadline-Bold-Web.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
                        dangerouslySetInnerHTML: {
                            __html: GlobalCss
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Page, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("min-height:100vh;margin:0 auto;"),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuPanel/* default */.ZP, {
                                active: isMenuOpen,
                                toggleMenuOpen: toggleMenuOpen
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuPanel/* MenuOverlay */.TJ, {
                                onClick: toggleMenuOpen,
                                active: isMenuOpen
                            }),
                            !props.hideHeader && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                                isMenuOpen: isMenuOpen,
                                toggleMenuOpen: toggleMenuOpen,
                                hideHeaderNavLinks: props.hideHeaderNavLinks
                            }),
                            props.children
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var shared_Layout = (Layout);


/***/ }),

/***/ 3542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15467);
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26198);
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _opendoor_shared_fe_build_sagas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2775);
/* harmony import */ var _opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95718);
/* harmony import */ var _opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4544);
/* harmony import */ var _opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21597);
/* harmony import */ var redux_immutable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72739);
/* harmony import */ var redux_saga__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87200);
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92242);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35480);













var sagas = function sagas() {
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__.all)([
                        (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__.fork)(new (_opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4___default())(new (_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1___default())(_globals__WEBPACK_IMPORTED_MODULE_9__/* .XSRF_COOKIE_KEY */ .x0, _globals__WEBPACK_IMPORTED_MODULE_9__/* .RAILS_URL */ .oF)).saga)
                    ])
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
};
var sagaMiddleware = (0,redux_saga__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)({
    onError: _opendoor_shared_fe_build_sagas__WEBPACK_IMPORTED_MODULE_2__/* .sagaMiddlewareErrorHandler */ .e
});
var composeEnhancers = ( true && window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_5__/* .compose */ .qC;
var reducers = {
    session: (_opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3___default().reducer)
};
var store = (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .createStore */ .MT)((0,redux_immutable__WEBPACK_IMPORTED_MODULE_6__/* .combineReducers */ .U)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, reducers)), undefined, composeEnhancers((0,redux__WEBPACK_IMPORTED_MODULE_5__/* .applyMiddleware */ .md)(sagaMiddleware)));
sagaMiddleware.run(sagas);
var ReduxWrapper = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(react_redux__WEBPACK_IMPORTED_MODULE_0__/* .Provider */ .zt, {
        store: store,
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReduxWrapper);


/***/ })

}]);